import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';

/**
 * Gates a route behind an authenticated session.
 * - loading → dark spinner
 * - auth not configured in this build (e.g. prod before its Supabase project
 *   exists) → render through; the backend still gates sensitive actions
 *   independently, so we never lock users out of a page client-side-only.
 * - no session → redirect to /entrar, remembering where they came from.
 */
export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading, configured } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[calc(100vh-4rem)] bg-ink-950 flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-ink-700 border-t-ember animate-spin" />
      </div>
    );
  }

  if (!configured) return <>{children}</>;
  if (!user) return <Navigate to="/entrar" state={{ from: location.pathname }} replace />;
  return <>{children}</>;
}
